import React, {Component} from 'react';
import {Page, ContentBlockTitle, ContentBlock} from 'framework7-react';

/// Displays basic information about the Iowa Architecture Foundation.
export class About extends Component {
    render() {
        if (this.props.content === null) {
            return <Page>
                <ContentBlockTitle>Welcome to IAF Tours!</ContentBlockTitle>
            </Page>;
        }

        return (
            <Page>
                <ContentBlockTitle>{this.props.content.title}</ContentBlockTitle>
                <ContentBlock inner>
                    <div dangerouslySetInnerHTML={{__html: this.props.content.content}}></div>
                </ContentBlock>
            </Page>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/About.jsx